<div *ngIf="withCheckboxSelection && checkedRowsId.size > 0 && withActions" class="multiple-rows-actions">
  <div class="left-container">
    <div>
      {{ expandFilterResultControl.value ? pageInfo.totalItems : checkedRowsId.size }}
      {{ 'tableActionsAndFilters.selectedRowsText' | labelsProvider }}
    </div>
    @if (withExpandFilters) {
      <div>
        {{ 'tableActionsAndFilters.expandResultsText' | labelsProvider }}
      </div>
      <mat-checkbox
        color="primary"
        [formControl]="expandFilterResultControl"
        (click)="$event.stopPropagation()"
        [matTooltip]="'common.violationsBulkTooltip' | labelsProvider"
        matTooltipPosition="below"
        matTooltipClass="tooltip-container"
      >
      </mat-checkbox>
    }
  </div>
  <app-actions-menu-select
    class="multi-actions"
    [actions]="(checkedRowsSupportedActions$ | async) ?? []"
    [forceUsingSelectOptions]="true"
    (actionOnClick)="multiCheckOnClick.emit($event)"
  >
  </app-actions-menu-select>
</div>

<p-table
  class="main-table"
  [ngClass]="{
    'clickable-table': withRowSelection,
    'checked-rows-visible': checkedRowsId.size > 0,
  }"
  [tableStyle]="{
    'table-layout': 'fixed',
    width: '100%',
  }"
  (keydown.escape)="onEscKey($event)"
  [value]="(data$ | async) ?? []"
  selectionMode="single"
  metaKeySelection="true"
  [columns]="selectedColumns()"
  [lazy]="true"
  (onLazyLoad)="onLazyLoad($event)"
  [paginator]="true"
  [rows]="rowsPerPage ?? undefined"
  [scrollable]="true"
  [totalRecords]="pageInfo.totalItems"
  [loading]="isLoading"
  [resizableColumns]="true"
  columnResizeMode="fit"
  (onColResize)="checkTruncation()"
  (clickOutside)="clickedOutside($event)"
  [customSort]="true"
  [sortField]="sortKey"
  [sortOrder]="sortOrder"
  (sortFunction)="onSortClick($event)"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {{ pageInfo.totalItems | number }} entries"
  [showFirstLastIcon]="false"
  [pageLinks]="1"
  [first]="(pageInfo.number - 1) * pageInfo.maxSize"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <!-- Check box column -->
      <th *ngIf="withCheckboxSelection" style="width: 50px">
        <mat-checkbox
          color="primary"
          [formControl]="allCheckedControl"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
      </th>
      <!-- Platform icon column -->
      <th *ngIf="tabelWithIcon" style="width: 50px"></th>
      <!-- Spacer column for resize buffer -->
      <th *ngIf="withSpacerColumn" style="width: 5px"></th>
      <ng-container *ngFor="let col of columns">
        <th
          *ngIf="col.sortKey"
          pResizableColumn
          [pSortableColumn]="col.sortKey"
          [pSortableColumnDisabled]="col.isSortableDisabled"
          [ngStyle]="{
            width: col.width + 'px',
          }"
          [matTooltip]="col.headerTooltip"
          matTooltipPosition="above"
          matTooltipClass="tooltip-container"
          (click)="$event.stopPropagation()"
        >
          {{ col.header }}
          <p-sortIcon [field]="col.sortKey" [ngClass]="{ 'invert-sort-icon': col.invertSortIcon }"></p-sortIcon>
        </th>
        <th
          *ngIf="!col.sortKey"
          pResizableColumn
          [ngStyle]="{
            width: col.width + 'px',
          }"
          [matTooltip]="col.headerTooltip"
          matTooltipPosition="above"
          matTooltipClass="tooltip-container"
        >
          {{ col.header }}
        </th>
      </ng-container>
      <!-- Actions Column -->
      <th *ngIf="withActions" style="width: 100px"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-columns="columns">
    <tr
      [pSelectableRow]="row"
      class="table-row"
      [class.p-highlight]="row === selectedRow()"
      (focus)="onRowFocus($event, row)"
      (keydown.arrowup)="selectRowByArrowKey($event, Direction.UP)"
      (keydown.arrowdown)="selectRowByArrowKey($event, Direction.DOWN)"
      (click)="onRowClicked($event, row)"
    >
      <td *ngIf="withCheckboxSelection" style="width: 50px">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          [checked]="checkedRowsId.has(row.rowId)"
          (change)="onCheckboxClick(row.rowId)"
          [disabled]="expandFilterResultControl.value"
        >
        </mat-checkbox>
      </td>
      <td *ngIf="tabelWithIcon" style="width: 50px">
        <img class="icon-field" [src]="row.platformIcon" [alt]="row.platform" />
      </td>
      <!-- Spacer column for resize buffer -->
      <td *ngIf="withSpacerColumn" style="width: 20px"></td>
      <td
        *ngFor="let col of columns"
        [ngSwitch]="col.type"
        [ngStyle]="{
          width: col.width + 'px',
        }"
      >
        <img *ngSwitchCase="tableColumnTypeEnum.Icon" class="icon-field" [src]="row[col.prop]" />
        <app-severity-label
          *ngSwitchCase="tableColumnTypeEnum.SeverityLabel"
          [severity]="row[col.prop]"
          [wideSize]="col.prop === 'businessCriticality'"
        ></app-severity-label>
        <app-status-label
          *ngSwitchCase="tableColumnTypeEnum.StatusLabel"
          [statusLabel]="row[col.prop]"
        ></app-status-label>
        <app-possible-na-status-cell
          *ngSwitchCase="tableColumnTypeEnum.StatusLabelOrNA"
          [statusLabel]="row[col.prop]"
          [toolTip]="row[col.tooltipDynamicText]"
        ></app-possible-na-status-cell>
        <app-view-labels-multi-select
          *ngSwitchCase="tableColumnTypeEnum.Label"
          [labelBindings]="row[col.prop]"
          [canBeRemoved]="false"
          [areMerged]="true"
          [multipleRows]="false"
        >
        </app-view-labels-multi-select>
        @if (col.prop === 'permissions') {
          <div
            *ngSwitchCase="tableColumnTypeEnum.Tag"
            cdkOverlayOrigin
            #permOrigin="cdkOverlayOrigin"
            (mouseenter)="openPermOverlay(permOrigin, 'Operator', row[col.prop])"
            (mouseleave)="schedulePermOverlayClose(0)"
          >
            <app-multiple-tags [tags]="row[col.prop].toString().trim()"></app-multiple-tags>
          </div>
        } @else {
          <app-multiple-tags
            *ngSwitchCase="tableColumnTypeEnum.Tag"
            [tags]="row[col.prop].toString().trim()"
          ></app-multiple-tags>
        }
        <app-single-tag
          *ngSwitchCase="tableColumnTypeEnum.SingleTag"
          [tag]="row[col.prop].toString().trim()"
        ></app-single-tag>
        <app-possible-na-cell
          #cellRef
          *ngSwitchCase="tableColumnTypeEnum.TextOrNA"
          [text]="row[col.prop]"
          [toolTip]="row[col.tooltipDynamicText]"
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
        </app-possible-na-cell>
        <app-possible-na-multi-value-cell
          #cellRef
          *ngSwitchCase="tableColumnTypeEnum.MultiValueOrNA"
          [values]="row[col.prop]"
          [toolTip]="row[col.tooltipDynamicText]"
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
        </app-possible-na-multi-value-cell>
        <ng-container *ngSwitchCase="tableColumnTypeEnum.CopyableText">
          @if (row[col.prop] && row[col.prop].toString().trim()) {
            @if (!col.iconOnly) {
              <app-copy-button
                [value]="
                  col.toCapitalize
                    ? (row[col.prop].toString().trim() | beautifyDisplayString)
                    : row[col.prop].toString().trim()
                "
                text="{{
                  col.customCopyButtonTextLabel
                    ? (col.customCopyButtonTextLabel | labelsProvider)
                    : col.toCapitalize
                      ? (row[col.prop].toString().trim() | beautifyDisplayString)
                      : row[col.prop].toString().trim()
                }}"
                [isSecondaryFontColor]="true"
                [successPopupPosition]="copyButtonPopupPosition"
                [withCopyIcon]="col.withCopyIcon ? true : false"
              >
              </app-copy-button>
            } @else {
              <app-copy-button
                [value]="
                  col.toCapitalize
                    ? (row[col.prop].toString().trim() | beautifyDisplayString)
                    : row[col.prop].toString().trim()
                "
                [isSecondaryFontColor]="true"
                [successPopupPosition]="copyButtonPopupPosition"
                [title]="
                  col.toCapitalize
                    ? (row[col.prop].toString().trim() | beautifyDisplayString)
                    : row[col.prop].toString().trim()
                "
              >
              </app-copy-button>
            }
          }
        </ng-container>

        <app-anchor-link
          *ngSwitchCase="tableColumnTypeEnum.LinkNewPage"
          [navigation]="row[col.linkPropertyKey]"
          class="prime-table__link-cell"
        >
          <span
            #cellRef
            [attr.data-row-id]="row.rowId"
            [attr.data-col-key]="col.prop"
            matTooltip="{{ row[col.prop] }}"
            matTooltipPosition="below"
            [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
            class="link ellipsis"
            >{{ row[col.prop] }}</span
          >
        </app-anchor-link>

        <div
          *ngSwitchCase="tableColumnTypeEnum.Date"
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
          {{ row[col.prop] ? (row[col.prop] | date: 'mediumDate') : '' }}
        </div>
        <div
          *ngSwitchCase="tableColumnTypeEnum.DateTime"
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
          {{ row[col.prop] ? (row[col.prop] | date: col.dateFormat || 'medium') : '' }}
        </div>
        <div
          *ngSwitchCase="tableColumnTypeEnum.TextWithIconAndTooltip"
          style="display: flex; align-items: center"
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
          {{ col.toCapitalize ? (row[col.prop] | beautifyDisplayString) : row[col.prop] }}
          <div>
            <img
              class="status-label-icon"
              [src]="row[col.iconSrc]"
              [matTooltip]="row[col.tooltipIconText]"
              *ngIf="row[col.tooltipIconText]"
              style="padding-top: 9px"
            />
          </div>
        </div>
        <!-- Text with Icon -->
        <div *ngSwitchCase="tableColumnTypeEnum.TextWithIcon" class="text-with-icon">
          @if (row[col.iconSrc] && row[col.iconSrc].toString().startsWith('lucide:')) {
            <lucide-icon
              class="icon"
              [name]="row[col.iconSrc].toString().replace('lucide:', '')"
              [size]="14"
              [strokeWidth]="1.5"
            >
            </lucide-icon>
          } @else if (row[col.iconSrc]) {
            <img
              [ngClass]="row[col.iconTableClass] || 'icon-field'"
              [src]="row[col.iconSrc]"
              [alt]="row[col.iconAlt]"
              style="margin-right: 5px"
              (error)="onIconError($event)"
            />
          }
          @if (col.withTruncation) {
            <div
              #cellRef
              [attr.data-row-id]="row.rowId"
              [attr.data-col-key]="col.prop"
              [matTooltip]="row[col.prop]"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
              [ngStyle]="{ color: row[col.textColor] || null }"
            >
              {{ col.toCapitalize ? (row[col.prop] | beautifyDisplayString) : row[col.prop] }}
            </div>
          } @else {
            <div [ngStyle]="{ color: row[col.textColor] || null }">
              {{ col.toCapitalize ? (row[col.prop] | beautifyDisplayString) : row[col.prop] }}
            </div>
          }
        </div>

        <div
          *ngSwitchCase="tableColumnTypeEnum.TextPopup"
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          (click)="onTextPopupCellClick(row, col)"
          class="clickable-column"
        >
          {{ row[col.prop] }}
        </div>

        <div
          *ngSwitchCase="tableColumnTypeEnum.Avatar"
          class="prime-table__cell"
          [ngClass]="{ disabled: col.disabledProp ? row[col.disabledProp] : false }"
        >
          @if (row[col.prop] && row[col.prop].length > 1) {
            <p-avatarGroup>
              @for (avatarLabel of row[col.prop]; track avatarLabel) {
                <p-avatar
                  [label]="avatarLabel[0] | uppercase"
                  shape="circle"
                  [style]="avatarLabel | avatarStyle"
                  (click)="$event.stopPropagation()"
                />
              }
            </p-avatarGroup>
          } @else {
            @if (row[col.prop] && row[col.prop][0] === 'N/A') {
              <span>{{ row[col.prop][0] }}</span>
            } @else {
              <p-avatar
                [label]="row[col.prop][0][0] | uppercase"
                shape="circle"
                [style]="row[col.prop][0] | avatarStyle"
                (click)="$event.stopPropagation()"
              />
              <span>{{ row[col.prop][0] }}</span>
            }
          }
        </div>

        <div *ngSwitchCase="tableColumnTypeEnum.Severities" class="prime-table__cell">
          <app-severities-cell [severities]="row[col.prop]" />
        </div>

        <div
          *ngSwitchCase="tableColumnTypeEnum.AvatarsList"
          class="prime-table__cell users-avatars"
          cdkOverlayOrigin
          #usersOrigin="cdkOverlayOrigin"
          (mouseenter)="openUsersOverlay(usersOrigin, row[col.prop])"
          (mouseleave)="scheduleUsersOverlayClose()"
        >
          @if (row[col.prop]; as users) {
            @for (u of users | slice: 0 : 5; track $index) {
              <p-avatar
                [label]="('' + u).length ? ('' + u).charAt(0).toUpperCase() : '?'"
                shape="circle"
                [style]="'' + u | avatarStyle"
              ></p-avatar>
            }
            @if (users.length > 5) {
              <span class="users-overflow">+{{ users.length - 5 }}</span>
            }
          }
        </div>

        <div
          *ngSwitchDefault
          #cellRef
          [attr.data-row-id]="row.rowId"
          [attr.data-col-key]="col.prop"
          matTooltip="{{ row[col.prop] }}"
          matTooltipPosition="below"
          [matTooltipDisabled]="!isTruncated(row.rowId, col.prop)"
          class="ellipsis"
        >
          {{ col.toCapitalize ? (row[col.prop] | beautifyDisplayString) : row[col.prop] }}
        </div>
      </td>
      <td style="width: 50px" *ngIf="withActions">
        <div class="actions-column-icon" (click)="$event.stopPropagation()">
          <app-actions-menu-icon
            *ngIf="row.menuActions.length > 0"
            class="actions-icon"
            [actions]="row.menuActions"
            (actionOnClick)="actionOnClick($event, row)"
            [smallSize]="true"
          >
          </app-actions-menu-icon>
        </div>
      </td>
    </tr>
  </ng-template>
  <!-- When the table is empty ( data length 0) we get here -->
  <ng-template pTemplate="emptymessage">
    <app-no-data [tableNotFoundText]="tableNotFoundText" [tableNotFoundIcon]="tableNotFoundIcon"></app-no-data>
  </ng-template>
</p-table>

<!-- Global users overlay (one per table) -->
<ng-template
  cdk-connected-overlay
  [cdkConnectedOverlayOpen]="overlays.users.open()"
  [cdkConnectedOverlayOrigin]="$any(overlays.users.origin())"
  [cdkConnectedOverlayPositions]="usersOverlayPositions"
  (overlayOutsideClick)="closeUsersOverlay()"
  (detach)="closeUsersOverlay()"
  (positionChange)="onUsersOverlayAttached()"
>
  <div
    class="users-popover users-popover-overlay"
    (mouseenter)="cancelUsersOverlayClose()"
    (mouseleave)="scheduleUsersOverlayClose()"
  >
    <div class="users-popover-content" #usersOverlayContent>
      @for (em of overlays.users.data(); track $index) {
        <div class="users-popover-item">
          <p-avatar
            [label]="('' + em).length ? ('' + em).charAt(0).toUpperCase() : '?'"
            shape="circle"
            [style]="'' + em | avatarStyle"
          ></p-avatar>
          <span class="email">{{ em }}</span>
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- Global permissions overlay (one per table) -->
<ng-template
  cdk-connected-overlay
  [cdkConnectedOverlayOpen]="overlays.perm.open()"
  [cdkConnectedOverlayOrigin]="$any(overlays.perm.origin())"
  [cdkConnectedOverlayPositions]="usersOverlayPositions"
  (overlayOutsideClick)="closePermOverlay()"
  (detach)="closePermOverlay()"
>
  <div
    class="users-popover users-popover-overlay"
    (mouseenter)="cancelPermOverlayClose()"
    (mouseleave)="schedulePermOverlayClose(0)"
  >
    <div class="users-popover-content">
      <div class="perm-title">{{ overlays.perm.title() }} ({{ overlays.perm.items().length }})</div>
      @for (item of overlays.perm.items(); track $index) {
        <div class="users-popover-item">
          @if (item.icon) {
            <img [src]="item.icon" alt="" class="perm-icon" />
          }
          <span class="email">{{ item.name }}</span>
        </div>
      }
    </div>
  </div>
</ng-template>
